/**
 * FullStacked Cloud Console - Primary section tab bar (below the minimal top bar).
 */

import { NAV_ITEMS } from "../lib/nav.ts";
import type { Route, TopView } from "../lib/router.ts";
import { Icon, type IconName } from "../ui/icons.tsx";

const ICONS: Record<TopView, IconName> = {
    projects: "projects",
    data: "data",
    tunnels: "tunnels",
    users: "users",
    agents: "agents",
    settings: "settings",
};

export function NavTabs(props: { active: TopView | null; onSelect: (route: Route) => void }) {
    return (
        <nav className="nav-tabs" aria-label="Console sections">
            {NAV_ITEMS.map((item) => (
                <button
                    key={item.id}
                    className={`tab-btn ${props.active === item.id ? "active" : ""}`}
                    aria-current={props.active === item.id ? "page" : undefined}
                    onClick={() => props.onSelect(item.route)}
                >
                    <Icon name={ICONS[item.id]} />
                    {item.label}
                </button>
            ))}
        </nav>
    );
}
